export default __webpack_public_path__ + "static/media/screen21.5f7073b6.svg";